window.app.controller('partnerLoginCtrl', ['$location', '$scope', function ($location, $scope) {

    $scope.partnerInfo = {};
    $scope.passInfo = {};
    $scope.requestOnMail = false;
    $scope.showError = false;
    $scope.notEnabled = false;

    $scope.sendAuthInfo = () => {
      $scope.partnerInfo.type = 'partner';
        $scope.sendXHR({
            url: $scope.url,
            data: $scope.partnerInfo,
            successFunc: $scope.requestSuccess,
            errorFunc: $scope.fail
        });
    };

    $scope.fail = (resp) => {
        $scope.messageAlert = resp.data.message;
    };

    $scope.requestSuccess = (resp) => {
        $scope.message = resp.data.message;
        if (resp.data.authSuccess) {
            $scope.redirect(resp.data.authUrl);
        } else if (resp.data.authSuccess === false) {
            if (resp.data.message === 'Wygląda na to, że próbujesz zalogować się jako partner') {
                document.getElementById("messageAlert").innerHTML = `<a target="_blank" href="/login/">${$scope.message}</a>`
            } else if (resp.data.message === 'Twój e-mail nie został zatwierdzony. Aby utworzyć nowe hasło, należy aktywować link, który został przeslany w wiadomości e-mail') {
                $scope.userMailAgentLink = `http://${$scope.partnerInfo.email.split('@')[1]}`;
                document.getElementById("enabledAlert").innerHTML = `<a target="_blank" href="${$scope.userMailAgentLink}">${$scope.message}</a>`;
                $scope.notEnabled = true;
            } else {
                document.getElementById("messageAlert").innerHTML = `<a>${$scope.message}</a>`
            }
        } else if (resp.data.requestSuccess) {
            $scope.requestOnMail = true;
        } else if (resp.data.requestSuccess === false) {
            $scope.showError = true;
        } else if (resp.data.changeSuccess) {
            window.location.href = '/affiliate-program';
        } else if (resp.data.changeSuccess === false) {
            document.getElementById("changeAlert").innerHTML = `<a>${$scope.message}</a>`
        }
    };


    $scope.formConfig = {}
    $scope.formConfigList = {
        default: {
            ttl: 'Wejście na profil',
            auth: true,
            request: false,
            execute: false,
            showForgot: true,
            showRegEmail: false,
            url: '/api/front/authorization/authorization/authorize',
        },
        requestChangePass: {
            ttl: 'Odzyskaj hasło',
            auth: false,
            request: true,
            execute: false,
            showForgot: true,
            showRegEmail: false,
            url: '/api/front/password/ask-pass/ask'
        },
        fromRegEmail: {
            ttl: 'Zmiana hasła',
            auth: false,
            request: false,
            execute: true,
            showForgot: false,
            showRegEmail: false,
            url: '/api/front/password/change-pass/change'
        },
        regEmail: {
            ttl: 'Rejestracja w Programie Partnerskim Racoongo.com',
            auth: false,
            request: false,
            execute: false,
            showForgot: true,
            showRegEmail: true,
            url: ''
        },
    }

    $scope.setFormConfig = (status = 'default') => {
        let params = window.location.search.replace('?', '').split('&').reduce(
            function (p, e) {
                let a = e.split('=');
                p[decodeURIComponent(a[0])] = decodeURIComponent(a[1]);
                return p;
            },
            {}
        );
        if (params['fromRegEmail']) {
            $scope.formConfig = $scope.formConfigList['fromRegEmail'];
            $scope.formConfigList['fromRegEmail'].url = '/api/front/password/change-pass/change?key=' + params['key']
        } else if (params['regEmail']) {
            $scope.formConfig = $scope.formConfigList['regEmail'];
        }else {
            $scope.formConfig = $scope.formConfigList[status]
        }
        $scope.url = $scope.formConfig.url;
    };

    $scope.sendMessage = () => {
        $scope.sendXHR({
            url: '/api/front/registration/registration/resend-letter',
            data: {
              type: 'partner',
                email: $scope.partnerInfo.email
            },
            successFunc: '',
            errorFunc: $scope.fail
        });
    };
}
]) 
;



// WEBPACK FOOTER //
// src/js/controllers/partner/loginCtrl.js